import type { CourseChatTarget } from '../types/course';
import type { ThreadItem } from '../hooks/useChatThreads';
/** Where a new conversation about a chart starts: the own chart is the natal chat, another person's carries its id. */
export function newChatHref(chart: { id: string; isSelf: boolean }): string {
  return chart.isSelf
    ? '/chat?surface=natal&seedRef=natal:self'
    : `/chat?chartId=${encodeURIComponent(chart.id)}&surface=chart`;
}

/** Home «Чат с Calestea»: opens the latest conversation, or a new one about «Я» when there is none yet. */
export const CHAT_ENTRY_HREF = '/chat/open';

/**
 * Where the persona picker sends the user for a chart: its latest conversation, or a new one.
 * `threads` is the full list, newest first. The own chart also owns conversations with no chart id.
 */
export function personaChatHref(
  chart: { id: string; isSelf: boolean },
  threads: ReadonlyArray<{ id: string; chartId: string | null; surface?: string }>,
): string {
  const last = threads.find((th) => th.surface !== 'course' && (th.chartId === chart.id || (chart.isSelf && th.chartId === null)));
  return last ? threadHref(last.id) : newChatHref(chart);
}

/** Opens a saved conversation. */
export const threadHref = (id: string): string => `/chat?thread=${encodeURIComponent(id)}`;

/** Course URLs carry ids only; the server returns the saved answer and current quote. */
export const courseChatHref = (target: CourseChatTarget): string => `/course/chat?${new URLSearchParams(target as Record<string, string>)}`;
export const historyThreadHref = (thread: Pick<ThreadItem, 'id' | 'surface'>): string => thread.surface === 'course' ? `/course/chat?thread=${encodeURIComponent(thread.id)}` : threadHref(thread.id);
